import { useEffect, useMemo, useState } from "react"
import "./CenterCoordinator.css"
import { Row, Descriptions,Card, Avatar,Typography,Space } from "antd"
import { useLocation, useHistory} from "react-router-dom"
import { convertDateToOnlyDate,convertDateToTime } from "../../../utils/TranformDate";
import { 
    TwitterOutlined,
    FacebookOutlined,
    WhatsAppOutlined,
    InstagramOutlined,
  } from "@ant-design/icons";

const {Text} = Typography;
const {Meta} = Card;

export default function CenterCoordinator(params){
    const {Body,DefaultProfile}=params
    const [coordinatorCenterRol,setCoordinatorCenterRol]=useState([]);
    const [coordinatorCenter,setCoordinatorCenter]=useState([]);
    const [coordinatorCenterContact,setCoordinatorCenterContact]=useState([]);
    const history = useHistory();
    const { search } = useLocation();
    const searchParams = useMemo(
        () => new URLSearchParams(search),[search]
      );
    const [pictureProfile,setPictureProfile]=useState(null)

    useEffect(()=>{
        setAllUseState();
        if (searchParams.get('option')!=="dataCoordinator") {
            searchParams.set('option', 'dataCoordinator');
            history.replace({ search: searchParams.toString() });
        }
        changePictureCoordinator()
    },[])


    const changePictureCoordinator=()=>{
        if(Body?.User?.picture!=null){
            setPictureProfile(`https://drive.google.com/uc?export=download&id=${Body?.User?.picture}`)
        }else{
            setPictureProfile(DefaultProfile)
        }
    }

    const setAllUseState=()=>{
        setCoordinatorCenterRol(Body?.User?.SystemRol);
        setCoordinatorCenterContact(Body?.User?.Contact);
        setCoordinatorCenter(Body?.User);

    }

    // const convertDateToOnlyDate=(date)=> {
    //     if(date==="null"){
    //         const newDate=new Date(date);
    //         const year=newDate.getFullYear();
    //         const month=newDate.getMonth();
    //         const day=newDate.getDay();
    //         /*month=month<10? "0"+month: month
    //         day=day<10? "0"+day:day
    //         console.log(year,month,day)*/
    //         return newDate.toLocaleDateString();
    //     }
    //     else{
    //         return date;
    //     }
    // }
    // function convertDateToTime(date) {
    //     const newDate=new Date(date);
    //     return newDate.toLocaleTimeString();
    // }

    return(
        <>
        {/* <div style={{background:"gray", borderColor:"violet", wordWrap:"break-word"}}>
        </div> */}
        <Card 
        bordered={false}
        bodyStyle={{backgroundColor:"whitesmoke"}}
        >
            {/* <Row style={{padding:10}} align={"center"}>
                <Col span={4} >
                    <Card bordered={false}>
                        <Image  ></Image>
                    </Card>
                </Col>
                {/* <Col span={8} offset={12}>
                    <Card bordered={false}>
                        <Image src={logoCenter}></Image>
                    </Card>
                </Col>
            </Row>*/}
            <Row>
                <Card 
                headStyle={{textAlign: "center"}}
                style={{width:"100%"}} 
                bordered={false}
                >
                    <Card>
                    <Meta
                    avatar={<Avatar shape="square" src={pictureProfile}/>}
                    title={`Coordinador del ${Body.acronym}`}
                    description={`Datos propios del coordinador`}
                    ></Meta>
                    </Card>
                    <Descriptions   
                    bordered={true}
                    >
                        <Descriptions.Item label="Nombres" span={3} >{coordinatorCenter?.firstName} </Descriptions.Item >
                        <Descriptions.Item label="Apellidos" span={3}>{coordinatorCenter?.lastName}</Descriptions.Item>
                        <Descriptions.Item label="Rol" span={3}>{coordinatorCenterRol?.name}</Descriptions.Item>
                        <Descriptions.Item label="Correo electornico" span={3}>{coordinatorCenter?.email}</Descriptions.Item>
                        <Descriptions.Item label="Correo electornico alternativo" span={3}>{coordinatorCenterContact?.email}</Descriptions.Item>
                        <Descriptions.Item label="Fecha de nacimiento"span={3}>{convertDateToOnlyDate(coordinatorCenter?.birthDate)}</Descriptions.Item>
                        <Descriptions.Item label="Numero de celular"span={3}>{coordinatorCenterContact?.cellPhone}</Descriptions.Item>
                        <Descriptions.Item label="Numero de telefono"span={3}>{coordinatorCenterContact?.phone}</Descriptions.Item>
                        <Descriptions.Item label="Numero de pasaporte"span={3}>{coordinatorCenterContact?.passport}</Descriptions.Item>
                        <Descriptions.Item label="Carnet de identidad"span={3}>{coordinatorCenterContact?.userCI}</Descriptions.Item>
                        <Descriptions.Item label="Pais de origen"span={3}>{coordinatorCenterContact?.ubication}</Descriptions.Item>
                        <Descriptions.Item label="Redes sociales"span={3}>
                            <Space direction="vertical">
                                <Text> <FacebookOutlined /> {coordinatorCenterContact?.socialNetworks?.facebook}</Text>

                                <Text> <WhatsAppOutlined /> {coordinatorCenterContact?.socialNetworks?.whatsapp}</Text>

                                <Text>  <InstagramOutlined /> {coordinatorCenterContact?.socialNetworks?.instagram}</Text>

                                <Text> <TwitterOutlined />  {coordinatorCenterContact?.socialNetworks?.twitter }</Text>
                            </Space>
                        </Descriptions.Item>
                        <Descriptions.Item label="Fecha de creacion"span={3}>{convertDateToOnlyDate(coordinatorCenter?.createdAt)}</Descriptions.Item>
                        <Descriptions.Item label="Hora de creacion"span={3}>{convertDateToTime(coordinatorCenter?.createdAt)}</Descriptions.Item>
                        <Descriptions.Item label="Fecha de actualización"span={3}>{convertDateToOnlyDate(coordinatorCenter?.updatedAt)}</Descriptions.Item>
                        <Descriptions.Item label="Hora de actualización"span={3}>{convertDateToTime(coordinatorCenter?.createdAt)}</Descriptions.Item>
                    </Descriptions>
                 </Card>
            </Row>
        </Card>
        </>
    )

}